import React from "react";
import { Congrats } from "@/components/Congrats";
import { Trans, useTranslation } from "react-i18next";
import { Student } from "@/__generated__/graphql";
import { useProtectedNavigation } from "@/routes/useProtectedNavigation";

interface BulkMessageCongratsProps {
  students?: Student[];
  totalCount: number;
}

export function BulkMessageCongrats({
  students,
  totalCount,
}: BulkMessageCongratsProps) {
  const { t } = useTranslation("translation", {
    keyPrefix: "bulkMessaging.congrats",
  });
  const { navToRoute } = useProtectedNavigation();

  return (
    <Congrats
      icon={<Congrats.CheckIcon />}
      title={t("sucessfullySent")}
      description={t("description")}
      className="h-[calc(100vh-15rem)] min-h-120 w-225 rounded-md border px-30 py-12"
      actions={
        <Congrats.ActionButton onClick={() => navToRoute("bulkMessaging")}>
          {t("done")}
        </Congrats.ActionButton>
      }
      avatars={
        <>
          <Congrats.Avatars
            count={6}
            imageUrls={students?.map(
              ({ profilePhoto }) => profilePhoto?.url || "",
            )}
          />
          <Congrats.AvatarLabel>
            <Trans
              i18nKey="bulkMessaging.congrats.studentCount"
              count={totalCount}
            >
              {totalCount} students
            </Trans>
          </Congrats.AvatarLabel>
        </>
      }
    />
  );
}
